import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { LoginComponent } from './features/auth/login/login.component';
import { RegisterComponent } from './features/auth/register/register.component';
import { UnauthorizedComponent } from './features/auth/unauthorized/unauthorized.component';
import { RefundTicketsComponent } from './features/refund-tickets/refund-tickets.component';
import { ResendTicketsComponent } from './features/resend-tickets/resend-tickets.component';
import { ActionHandlerComponent } from './features/auth/action-handler.component';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./features/travel/travel.module').then((m) => m.TravelModule)
      },
      {
        path: 'buscar/:origen_seo/:destino_seo',
        loadChildren: () =>
          import('./features/travel/travel.module').then((m) => m.TravelModule)
      },
      {
        path: 'butacas/:viaje_id',
        loadChildren: () =>
          import('./features/booking/booking.module').then((m) => m.BookingModule)
      },
      {
        path: 'butacas/:alias/:viaje_id/:origen_id/:destino_id/:categoria_id/:token',
        loadChildren: () =>
          import('./features/booking/booking.module').then((m) => m.BookingModule)
      },
      {
        path: 'checkout',
        loadChildren: () =>
          import('./features/checkout/checkout.module').then(m => m.CheckoutModule)
      },
      {
        path: 'login',
        component: LoginComponent
      },
      {
        path: 'register',
        component: RegisterComponent
      },
      {
        path: 'account',
        loadChildren: () => import('./features/account/account.routes').then(m => m.accountRoutes)
      },
      {
        path: 'refund',
        title: 'Devolver pasajes',
        component: RefundTicketsComponent,
      },
      {
        path: 'resend',
        title: 'Reenviar pasajes',
        component: ResendTicketsComponent,
      },
      {
        path: 'unauthorized',
        component: UnauthorizedComponent
      },
      { 
        path: "actions", 
        component: ActionHandlerComponent 
      }
    ]
  },
  { path: 'booking', loadChildren: () => import('./features/booking/booking.module').then(m => m.BookingModule) },
  {
    path: '**',
    redirectTo: ''
  }
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
